document.addEventListener('DOMContentLoaded', () => {

  let currentStep = 1;

  // FIXED
  let material = 'silver';
  let selectedDesign = 'Design 1';

  let finishMaterial = 'Gold Plated Brass';
  let stoneType = 'Cubic Zirconia';
let designPrice = 0;
let materialPrice = 0;
let stonePrice = 0;

let selectedFeatures = [];
let selectedFeaturePrice = 0;

  const slider = document.getElementById('pendantSize');
  const sizeNumber = document.getElementById('sizeNumber');
  const weightDisplay = document.getElementById('weightDisplay');

  // const pricing = {
  //   silver: {
  //     '1.5':[51170,70358],
  //     '2':[80000,100000],
  //     '2.5':[121528,147113],
  //     '3':[150000,180000],
  //     '3.5':[190000,230000],
  //     '4':[250000,300000]
  //   },

  //   gold: {
  //     '1.5':[120000,140000],
  //     '2':[160000,190000],
  //     '2.5':[220000,260000],
  //     '3':[280000,320000],
  //     '3.5':[340000,390000],
  //     '4':[400000,480000]
  //   }
  // };

  const weights = {
    '1.5':'30–55g',
    '2':'45–80g',
    '2.5':'65–110g',
    '3':'90–150g',
    '3.5':'120–190g',
    '4':'150–250g'
  };

function formatPrice(num){
  return '£' + Number(num).toLocaleString();
}

function updateStep1Price(){

  const step1Total =
    designPrice +
    materialPrice +
    stonePrice;

  const step1PriceDisplay =
    document.getElementById('step1PriceDisplay');

  if(step1PriceDisplay){
    step1PriceDisplay.innerHTML =
      '£' + step1Total.toLocaleString();
  }
}
function calculate(){

  const size = slider.value;

  const pricing =
    window.sizePricing || {};

  const base =
    pricing[size] || [0, 0];

  let finalMin =
    Number(base[0]) + selectedFeaturePrice;

  let finalMax =
    Number(base[1]) + selectedFeaturePrice;

  const priceDisplay =
    document.getElementById('priceDisplay');

  if(priceDisplay){
    priceDisplay.innerHTML =
      `${formatPrice(finalMin)} - ${formatPrice(finalMax)}`;
  }

  return {
    size,
    finalMin,
    finalMax,
    deposit: 0
  };
}

  function updateSliderUI(){

    const value = slider.value;

    if(sizeNumber){
      sizeNumber.innerHTML = value;
    }

    if(weightDisplay){
      weightDisplay.innerHTML = weights[value];
    }

    const percent =
      ((value - slider.min) /
      (slider.max - slider.min)) * 100;

    slider.style.background =
      `linear-gradient(
        to right,
        #313f4c 0%,
        #313f4c ${percent}%,
        #ddd ${percent}%,
        #ddd 100%
      )`;

    document
      .querySelectorAll('.slider-labels span')
      .forEach(label => {

        label.classList.remove('active');

        if(label.textContent.replace('"','') == value){
          label.classList.add('active');
        }

      });

    calculate();
  }

  if(slider){
    slider.addEventListener('input', updateSliderUI);
  }

  // MATERIAL
  document
    .querySelectorAll('[data-type="material"]')
    .forEach(item => {

      item.addEventListener('click', () => {

        document
          .querySelectorAll('[data-type="material"]')
          .forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        material = item.dataset.value;

        calculate();
      });

    });

  // DESIGN
  document
    .querySelectorAll('.design-card')
    .forEach(card => {

      card.addEventListener('click', () => {

        document
          .querySelectorAll('.design-card')
          .forEach(el => el.classList.remove('active'));

        card.classList.add('active');

selectedDesign = card.dataset.design;

designPrice =
  Number(card.dataset.price || 0);

updateStep1Price();
        const hiddenField =
          document.getElementById('selectedDesign');

        if(hiddenField){
          hiddenField.value = selectedDesign;
        }

      });

    });

  const selectedDesignField =
    document.getElementById('selectedDesign');

  if(selectedDesignField){
    selectedDesignField.value = selectedDesign;
  }

  const activeDesign =
  document.querySelector('.design-card.active');

if(activeDesign){
  designPrice =
    Number(activeDesign.dataset.price || 0);
}

const activeMaterial =
  document.querySelector('.finish-material.active');

if(activeMaterial){
  materialPrice =
    Number(activeMaterial.dataset.price || 0);
}

const activeStone =
  document.querySelector('.stone-option.active');

if(activeStone){
  stonePrice =
    Number(activeStone.dataset.price || 0);
}

updateStep1Price();

  // FINISH MATERIAL
  document
    .querySelectorAll('.finish-material')
    .forEach(item => {

      item.addEventListener('click', () => {

        document
          .querySelectorAll('.finish-material')
          .forEach(el => el.classList.remove('active'));

        item.classList.add('active');

        finishMaterial = item.dataset.value;

        const stoneOptions =
  document.querySelectorAll('.stone-option');

if (
  finishMaterial.toLowerCase().includes('silver')
) {

  stoneOptions.forEach(option => {

    const stoneName =
      option.dataset.value.toLowerCase();

    if (stoneName.includes('cubic')) {

      option.classList.add('disabled');

      option.style.pointerEvents = 'none';
      option.style.opacity = '0.4';

      if(option.classList.contains('active')){
        option.classList.remove('active');
      }

    }

    if (stoneName.includes('moissanite')) {

      option.classList.remove('disabled');

      option.style.pointerEvents = 'auto';
      option.style.opacity = '1';

      option.classList.add('active');

      stoneType = option.dataset.value;

      stonePrice =
        Number(option.dataset.price || 0);

      document.getElementById(
        'stoneTypeInput'
      ).value = stoneType;
    }

  });

} else {

  stoneOptions.forEach(option => {

    option.classList.remove('disabled');

    option.style.pointerEvents = 'auto';
    option.style.opacity = '1';

  });

}

materialPrice =
  Number(item.dataset.price || 0);

updateStep1Price();

        const field =
          document.getElementById('finishMaterialInput');

        if(field){
          field.value = finishMaterial;
        }

      });

    });

  // STONE
  document
    .querySelectorAll('.stone-option')
    .forEach(item => {

      item.addEventListener('click', () => {

        document
          .querySelectorAll('.stone-option')
          .forEach(el => el.classList.remove('active'));

        item.classList.add('active');

       stoneType = item.dataset.value;

stonePrice =
  Number(item.dataset.price || 0);

updateStep1Price();

        const field =
          document.getElementById('stoneTypeInput');

        if(field){
          field.value = stoneType;
        }

      });

    });



// EXTRA FEATURES

document
  .querySelectorAll('.feature-option')
  .forEach(item => {

    item.addEventListener('click', () => {

      item.classList.toggle('active');

      selectedFeatures = [];
      selectedFeaturePrice = 0;

      document
        .querySelectorAll('.feature-option.active')
        .forEach(feature => {

          selectedFeatures.push(feature.dataset.name);

          selectedFeaturePrice += Number(
            feature.dataset.price || 0
          );

        });

      const featureField =
        document.getElementById('extraFeaturesInput');

      if(featureField){
        featureField.value =
          selectedFeatures.join(', ');
      }

      calculate();

    });

  });

  // NEXT BUTTONS
  document
    .querySelectorAll('.next-btn')
    .forEach(btn => {

      btn.addEventListener('click', () => {

        const current =
          document.querySelector(
            `.pc-step[data-step="${currentStep}"]`
          );

        if(current){
          current.classList.remove('active');
        }

        currentStep++;

        const next =
          document.querySelector(
            `.pc-step[data-step="${currentStep}"]`
          );

        if(next){
          next.classList.add('active');
        }

        if(currentStep === 3){

          const result = calculate();

          const addonTotal =
  designPrice +
  materialPrice +
  stonePrice;

const totalMin =
  result.finalMin + addonTotal;

const totalMax =
  result.finalMax + addonTotal;

          const summaryHtml = `

  <div class="summary-row">
    <span class="summary-label">Pendant Size</span>
    <span class="summary-value">${result.size}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Design</span>
    <span class="summary-value">${selectedDesign}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Material</span>
    <span class="summary-value">${finishMaterial}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Stone</span>
    <span class="summary-value">${stoneType}</span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Extra Feature</span>
    <span class="summary-value">
      ${selectedFeatures.length
 ? selectedFeatures.join(', ')
 : 'None'}
    </span>
  </div>

  

  <div class="summary-row">
    <span class="summary-label">Estimated Price</span>
    <span class="summary-value">
     ${formatPrice(result.finalMin)}
-
${formatPrice(result.finalMax)}
    </span>
  </div>
<div class="summary-row">
  <span class="summary-label">Design Price</span>
  <span class="summary-value">
    £${designPrice}
  </span>
</div>

<div class="summary-row">
  <span class="summary-label">Material Price</span>
  <span class="summary-value">
    £${materialPrice}
  </span>
</div>

<div class="summary-row">
  <span class="summary-label">Stone Price</span>
  <span class="summary-value">
    £${stonePrice}
  </span>
</div>

<div class="summary-row">
  <span class="summary-label">Feature Cost</span>
  <span class="summary-value">
    £${selectedFeaturePrice}
  </span>
</div>
<div class="summary-row total-row">
  <span class="summary-label">
    Total Price
  </span>
  <span class="summary-value">
    ${formatPrice(totalMin)}
    -
    ${formatPrice(totalMax)}
  </span>
</div>

`;

          const summaryBox =
            document.getElementById('summaryBox');

          if(summaryBox){
            summaryBox.innerHTML = summaryHtml;
          }

          const hiddenSummary =
            document.getElementById('hiddenSummary');

          if(hiddenSummary){
hiddenSummary.value = `
Pendant Size: ${result.size}"
Design: ${selectedDesign}
Material: ${finishMaterial}
Stone: ${stoneType}
Extra Feature:
${selectedFeatures.length
 ? selectedFeatures.join(', ')
 : 'None'}
Feature Cost: £${selectedFeaturePrice}
Estimated Price: ${formatPrice(result.finalMin)} - ${formatPrice(result.finalMax)}
Total Estimate:
${formatPrice(totalMin)}
-
${formatPrice(totalMax)}
-
${formatPrice(result.finalMax)}
`;
          }
        }

      });

    });

  // BACK
  document
    .querySelectorAll('.back-btn')
    .forEach(btn => {

      btn.addEventListener('click', () => {

        const current =
          document.querySelector(
            `.pc-step[data-step="${currentStep}"]`
          );

        if(current){
          current.classList.remove('active');
        }

        currentStep--;

        const prev =
          document.querySelector(
            `.pc-step[data-step="${currentStep}"]`
          );

        if(prev){
          prev.classList.add('active');
        }

      });

    });

  updateSliderUI();
  calculate();

});


// FAQ TOGGLE

document.querySelectorAll('.faq-question').forEach(question => {

  question.addEventListener('click', () => {

    const item = question.parentElement;

    item.classList.toggle('active');

  });

});

const successBox = document.querySelector('.quote-success');

if(successBox){

  document
    .querySelectorAll('.pc-step')
    .forEach(step => step.classList.remove('active'));

  const step3 =
    document.querySelector('.pc-step[data-step="3"]');

  if(step3){
    step3.classList.add('active');
  }

  currentStep = 3;
}